import { useCallback, useEffect, useMemo, useState } from 'react';
import type { City, Sport } from '../types/landing';
import { buildInventory, type AreaInventory } from '../utils/inventory';

export type InventoryStatus = 'loading' | 'ready' | 'error';

export interface SportInventory {
  status: InventoryStatus;
  areas: AreaInventory[];
  venueCount: number;
  retry: () => void;
}

/** Simulates the i9 Sports backend call: GET /api/inventory?metro={city}&sport={sport} */
export function useSportInventory(city: City, sport: Sport): SportInventory {
  const [status, setStatus] = useState<InventoryStatus>('loading');
  const [areas, setAreas] = useState<AreaInventory[]>([]);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setStatus('loading');
    const timer = window.setTimeout(() => {
      setAreas(buildInventory(city, sport.slug));
      setStatus('ready');
    }, 650);
    return () => window.clearTimeout(timer);
  }, [city, sport, attempt]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);
  const venueCount = useMemo(() => areas.reduce((sum, a) => sum + a.venues.length, 0), [areas]);

  return { status, areas, venueCount, retry };
}
